import { render, staticRenderFns } from "./ConfDiscountTile.vue?vue&type=template&id=4d184579&scoped=true&"
import script from "./ConfDiscountTile.vue?vue&type=script&lang=js&"
export * from "./ConfDiscountTile.vue?vue&type=script&lang=js&"
import style0 from "./ConfDiscountTile.vue?vue&type=style&index=0&id=4d184579&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d184579",
  null
  
)

export default component.exports